import axios, { type AxiosResponse } from 'axios'

const apiUrl = import.meta.env.VITE_API_URL

export interface FeatureFlag {
	key: string
	label: string
	active: boolean
}

export default class FeatureFlagApi {
	route = 'users'

	async list(userId: number): Promise<AxiosResponse<FeatureFlag[]>> {
		return await axios.get(`${apiUrl}/${this.route}/${userId}/feature-flags`)
	}

	async toggle(
		userId: number,
		params: { feature: string; active: boolean },
	): Promise<AxiosResponse<FeatureFlag>> {
		return await axios.put(`${apiUrl}/${this.route}/${userId}/feature-flags`, params)
	}
}
